export const falseAgencyNamePlaceholders = ['login', 'account', 'register', 'dashboard', ''];

export const agencyNamePlaceholdersToIgnore = ['/', '/agency/', '/agency/dashboard', '/agency/recruiter-profiles', '/agency/recruiter-profiles', '/agency/create-profile', '/agency/job-opportunities'];
